import * as React from 'react';

const styles = require('./hasTourBadge.css');

export class HasTourBadge extends React.PureComponent<{}, {}> {
  public render() {
    return (<i className={styles['tour-badge']} data-tooltip-text="3D-тур по квартире" />);
  }
}
